const SizingEnum = Object.freeze({
  small: '.7rem',
  default: '.9rem',
  large: '1.1rem'
});

export default SizingEnum;
